// Spacing between top of page content and the order sumamry
export var ORDER_SUMMARY_OFFSET = 24;
export var ACTIVE_CART_PAGE_SEARCH_QUERIES_STORAGE_KEY = "ACTIVE_CART_PAGE_SEARCH_QUERIES_STORAGE_KEY";
export var SAVED_CART_PAGE_SEARCH_QUERIES_STORAGE_KEY = "SAVED_CART_PAGE_SEARCH_QUERIES_STORAGE_KEY";
